define('helperEntity-isTaskPage',[],function() {

    var isTaskPage = function(entity) {
        return (entity && Array.isArray(entity.questions) && Array.isArray(entity.answers) && (entity.questions.length || entity.answers.length)) ? true : false;
    };

    return isTaskPage;
});

